import React from "react";

export const IntroducingEazyBot = () => {
  return (
    <section
      id="about"
      data-testid="protocol-section"
      className="relative py-14 md:py-16 border-t border-white/10"
      style={{ background: "#1A1852" }}
    >
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="flex items-center justify-center gap-3 text-center">
          <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(66,165,245,0.65), transparent)" }} />
          <h2
            className="font-mono-label introducing-section-heading"
            style={{ color: "#E8C97A", letterSpacing: "0.12em" }}
            data-testid="protocol-heading"
          >
            DIGITAL EMPLOYEES
          </h2>
          <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(66,165,245,0.65), transparent)" }} />
        </div>

        <div className="mx-auto mt-8 grid max-w-5xl items-center gap-8 md:grid-cols-[0.95fr_1.05fr] md:gap-14">
          <div className="flex items-center justify-center" data-testid="introducing-robot-wrap">
            <img
              src="/eazybot-mascot.png"
              alt="EazyBot robot mascot"
              className="h-auto w-full max-w-[300px] object-contain sm:max-w-[345px] md:max-w-[390px]"
              style={{ filter: "drop-shadow(0 16px 35px rgba(3,172,239,0.22))" }}
              data-testid="introducing-robot-image"
            />
          </div>

          <div className="flex items-center justify-center">
            <div className="w-full max-w-[540px]" data-testid="introducing-content-group">
              <h2
                className="introducing-title-lift font-display text-center leading-[1.05] text-white"
                style={{ fontSize: "clamp(1.75rem, 3vw, 2.5rem)" }}
                data-testid="introducing-title"
              >
                Introducing EazyBot
              </h2>
              <div
                className="mt-5 space-y-5 text-center text-white/90"
                style={{ fontSize: "clamp(1rem, 1.35vw, 1.2rem)", lineHeight: 1.65, fontWeight: 400 }}
              >
                <p className="editorial-justify" data-testid="protocol-body-1">
                  EazyBot is a company that allows anyone to lease crypto trading bots that are continuously refined to earn consistent income for its users.
                </p>
                <p className="editorial-justify" data-testid="protocol-body-2">
                  This gives you and your family access to extra streams of easy income, because your trading bots do all the work but you get to keep the profits.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
